import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientProjectsSubscribersGrid: [],
    workClientProjectsSubscribersAll_project: [],
    workClientProjectsSubscribersShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientProjectsSubscribersGrid(state, payload) {
      state.workClientProjectsSubscribersGrid = payload
    },
    setWorkClientProjectsSubscribersAll_project(state, payload) {
      state.workClientProjectsSubscribersAll_project = payload
    },
    setWorkClientProjectsSubscribersShow(state, payload) {
      state.workClientProjectsSubscribersShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setDefaultProjectsSubscribers(state) {
      state.workClientProjectsSubscribersGrid = []
      state.workClientProjectsSubscribersAll_project = []
    },
  },
  getters: {
    workClientProjectsSubscribersGrid: (state) => {
      return state.workClientProjectsSubscribersGrid
    },
    workClientProjectsSubscribersAll_project: (state) => {
      return state.workClientProjectsSubscribersAll_project
    },
    workClientProjectsSubscribersShow: (state) => {
      return state.workClientProjectsSubscribersShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientProjectsSubscribersGrid({ commit, rootState }, { limit, page, sort, search }) {
      let url =
        rootState.apiDomain +
        '/api/admin/work/client/project/subscriber/grid?limit=' +
        limit +
        '&page=' +
        page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=id:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsSubscribersGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsSubscribersAll_project({ commit, rootState }, { project_id }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/subscriber/grid?limit=0&filter[]=project_id:' +
            project_id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsSubscribersAll_project', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsSubscribersShow({ commit, rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/subscriber/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsSubscribersShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsSubscribersCreate({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/subscriber',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsSubscribersUpdate({ rootState }, { data }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/subscriber',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsSubscribersDelete({ rootState }, { id }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/subscriber/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
